import React, { useEffect, useState } from "react";

import View1 from "../elements/view1/view1";
import View2 from "../elements/view2/view2";
import View3 from "../elements/view3/view3";
import View4 from "../elements/view4/view4";
import View5 from "../elements/view5/view5";
import View6 from "../elements/view6/view6";
import LandingHeader from "../elements/top_header/LandingHeader";
import BottomSection from "../elements/bottom-section/BottomSection";

import "./landing.scss";

const Landing = () => {
  const [showBottomSection, setShowBottomSection] = useState(false);

  const handleJumpTo = (section) => {
    document
      .getElementById(section ?? "header")
      .scrollIntoView({ behavior: "smooth" });
  };
  const handleNext = () => {
    window.location.href = "/new-form";
  };

  useEffect(() => {
    const onScroll = () =>
      window.scrollY > 400
        ? setShowBottomSection(true)
        : setShowBottomSection(false);
    window.addEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <LandingHeader id="header" />
      <div className="landing-container">
        <View1 handleJumpTo={handleJumpTo} />
        <View2 />
        <View3 />
        <View4 />
        <View5 />
        <View6 />
      </div>
      {showBottomSection && <BottomSection handleNext={handleNext} />}
    </>
  );
};
export default Landing;
